import { Smartphone, Loader2, CheckCircle2 } from "lucide-react";
import { OtpInput } from "@/components/OtpInput";

// Schermata di accesso del portale condòmino (email/password + accesso solo con OTP SMS).
// Componente presentazionale: riceve stato e handler dal contenitore CondominoPortal.
export const PortalLogin = ({
  Brand, PwField, fmtSecs, otpDemo,
  u, setU, pw, setPw, logErr, busy, login,
  smsMode, setSmsMode, smsErr, setSmsErr, setLogErr,
  smsStep, setSmsStep, smsPhone, setSmsPhone, smsBusy, smsHint, smsEntry,
  smsCode, setSmsCode, smsSuccess, smsResendIn, smsStart, smsVerify,
  showForgot, setShowForgot, forgotSent, setForgotSent, forgotUser, setForgotUser, forgotBusy, sendForgot,
}) => (
  <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center px-4" data-testid="condomino-login">
    <Brand />
    <div className="w-full max-w-sm bg-card border border-border rounded-2xl p-6 backdrop-blur">
      <h1 className="font-head text-xl font-extrabold tracking-tight">Portale condòmino</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-5">Entra in un attimo con il tuo <strong>numero di cellulare</strong>, oppure accedi con email e password.</p>

      {!smsMode && (
        <>
          <button
            data-testid="portal-sms-toggle"
            onClick={() => { setSmsMode(true); setSmsErr(""); setLogErr(""); setSmsStep("phone"); setShowForgot(false); }}
            className="group w-full flex items-center justify-center gap-2.5 rounded-xl border-2 border-[#007BFF]/25 bg-[#007BFF]/5 hover:bg-[#007BFF]/10 hover:border-[#007BFF]/50 text-[#007BFF] font-semibold text-sm py-3 transition-all duration-200 hover:shadow-[0_6px_20px_-8px_rgba(0,123,255,0.55)] active:scale-[0.985]"
          >
            <Smartphone className="h-4 w-4 transition-transform duration-200 group-hover:-rotate-6 group-hover:scale-110" />
            Entra solo con il numero di cellulare
          </button>
          <div className="flex items-center gap-3 my-4" aria-hidden="true">
            <span className="h-px flex-1 bg-border" />
            <span className="text-[11px] uppercase tracking-wide text-muted-foreground">oppure</span>
            <span className="h-px flex-1 bg-border" />
          </div>
        </>
      )}

      {!smsMode ? (
        <>
          <label className="text-[11px] uppercase tracking-wide text-muted-foreground">Email o numero di cellulare</label>
          <input data-testid="portal-username" value={u} onChange={(e) => setU(e.target.value)} placeholder="La tua email (o il tuo cellulare)" className="w-full mt-1 mb-3 bg-secondary border border-border rounded-lg px-3 py-2.5 text-sm outline-none focus:border-[#007BFF]" />
          <label className="text-[11px] uppercase tracking-wide text-muted-foreground">Password</label>
          <PwField data-testid="portal-password" value={pw} onChange={(e) => setPw(e.target.value)} onKeyDown={(e) => e.key === "Enter" && login()} placeholder="La tua password" className="w-full mt-1 mb-3 bg-secondary border border-border rounded-lg px-3 py-2.5 text-sm outline-none focus:border-[#007BFF]" />
          {logErr && <p className="text-red-400 text-xs mb-3" data-testid="portal-login-error">{logErr}</p>}
          <button data-testid="portal-login-btn" onClick={login} disabled={busy || !u || !pw} className="w-full bg-[#007BFF] hover:bg-[#0069D9] text-white rounded-lg py-2.5 text-sm font-semibold flex items-center justify-center disabled:opacity-50">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
          </button>

          <p className="text-[11px] text-muted-foreground text-center mt-3">
            Prima volta o password dimenticata? L'amministratore può inviarti un link per <strong>impostare la tua password</strong>, oppure usa il pulsante qui sotto.
          </p>
          <button data-testid="portal-forgot-link" onClick={() => { setShowForgot((v) => !v); setForgotSent(false); }} className="w-full text-center text-xs text-[#007BFF] hover:underline mt-2">
            Imposta / reimposta la password
          </button>

          {showForgot && (
            <div className="mt-3 pt-3 border-t border-border" data-testid="portal-forgot-box">
              {forgotSent ? (
                <p className="text-xs text-green-600" data-testid="portal-forgot-sent">Se l'utenza esiste, ti abbiamo inviato un'email con le istruzioni per reimpostare la password.</p>
              ) : (
                <>
                  <p className="text-[11px] text-muted-foreground mb-2">Inserisci il tuo utente/email: riceverai un link via email per reimpostare la password.</p>
                  <input data-testid="portal-forgot-input" value={forgotUser} onChange={(e) => setForgotUser(e.target.value)} placeholder="Utente o email" className="w-full mb-2 bg-secondary border border-border rounded-lg px-3 py-2 text-sm outline-none focus:border-[#007BFF]" />
                  <button data-testid="portal-forgot-send" onClick={sendForgot} disabled={forgotBusy || !forgotUser.trim()} className="w-full bg-secondary hover:bg-muted border border-border rounded-lg py-2 text-sm font-medium flex items-center justify-center disabled:opacity-50">
                    {forgotBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Invia link di reset"}
                  </button>
                </>
              )}
            </div>
          )}
        </>
      ) : (
        <div data-testid="portal-sms-box">
          {smsStep === "phone" ? (
            <>
              <label className="text-[11px] uppercase tracking-wide text-muted-foreground">Numero di cellulare</label>
              <input data-testid="portal-sms-phone" type="tel" value={smsPhone} onChange={(e) => setSmsPhone(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (otpDemo || smsPhone.trim()) && smsStart()} placeholder="Es. 333 1234567" className="w-full mt-1 mb-3 bg-secondary border border-border rounded-lg px-3 py-2.5 text-sm outline-none focus:border-[#007BFF]" />
              {smsErr && <p className="text-red-400 text-xs mb-3" data-testid="portal-sms-error">{smsErr}</p>}
              <button data-testid="portal-sms-send" onClick={smsStart} disabled={smsBusy || (!otpDemo && smsPhone.trim().length < 8)} className="w-full bg-[#007BFF] hover:bg-[#0069D9] text-white rounded-lg py-2.5 text-sm font-semibold flex items-center justify-center disabled:opacity-50">
                {smsBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : (otpDemo ? "Anteprima animazione OTP" : "Ricevi il codice di accesso")}
              </button>
              {otpDemo ? (
                <p className="text-[11px] text-amber-600 text-center mt-3">🎬 <strong>Modalità anteprima</strong>: premi il pulsante per vedere le caselle OTP. Inserisci <strong>123456</strong> per l'animazione di conferma, un altro codice per l'errore. Nessun SMS viene inviato.</p>
              ) : (
                <p className="text-[11px] text-muted-foreground text-center mt-3">Puoi entrare <strong>senza dati di accesso</strong>, solo con il tuo cellulare, <strong>a patto che il numero sia già stato inserito dall'amministratore</strong> in anagrafica. Riceverai un codice per confermare il telefono. Se il numero non risulta, chiedi all'amministratore di inserirlo.</p>
              )}
            </>
          ) : (
            <>
              <p className="text-sm text-muted-foreground mb-4">Ti abbiamo inviato un codice al numero <strong>{smsHint}</strong>. Inseriscilo qui sotto {smsEntry > 0 ? <>entro <strong data-testid="portal-sms-countdown">{fmtSecs(smsEntry)}</strong></> : "(il codice resta valido ancora qualche minuto)"}.</p>
              <label className="block text-[11px] uppercase tracking-wide text-muted-foreground mb-2 text-center">Codice ricevuto</label>
              <OtpInput
                length={6}
                value={smsCode}
                disabled={smsBusy}
                status={smsSuccess ? "success" : smsErr ? "error" : "idle"}
                onChange={(v) => { setSmsCode(v); if (smsErr) setSmsErr(""); }}
                onComplete={(v) => smsVerify(v)}
              />
              {smsSuccess ? (
                <p className="text-green-600 text-sm font-medium mt-4 mb-1 flex items-center justify-center gap-2" data-testid="portal-sms-success">
                  <CheckCircle2 className="h-5 w-5 otp-success-check" /> Codice corretto! Accesso in corso…
                </p>
              ) : smsErr ? (
                <p className="text-red-500 text-xs mt-3 mb-1 text-center" data-testid="portal-sms-error">{smsErr}</p>
              ) : null}
              {!smsSuccess && (
                <button data-testid="portal-sms-verify" onClick={() => smsVerify()} disabled={smsBusy || smsCode.trim().length !== 6} className="w-full bg-[#007BFF] hover:bg-[#0069D9] text-white rounded-lg py-2.5 text-sm font-semibold flex items-center justify-center disabled:opacity-50 mt-4">
                  {smsBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
                </button>
              )}
              {!smsSuccess && (
                <>
                  <button data-testid="portal-sms-resend" onClick={smsStart} disabled={smsBusy || smsResendIn > 0} className="w-full text-center text-xs text-[#007BFF] hover:underline mt-3 disabled:opacity-50 disabled:no-underline disabled:cursor-not-allowed">
                    {smsResendIn > 0 ? `Non l'hai ricevuto? Invia un nuovo codice tra ${smsResendIn}s` : "Non l'hai ricevuto? Invia un nuovo codice"}
                  </button>
                  <button data-testid="portal-sms-back" onClick={() => { setSmsStep("phone"); setSmsCode(""); setSmsErr(""); }} className="w-full text-center text-xs text-muted-foreground hover:underline mt-2">
                    Cambia numero
                  </button>
                </>
              )}
            </>
          )}
        </div>
      )}

      {smsMode && (
        <button data-testid="portal-sms-toggle" onClick={() => { setSmsMode(false); setSmsErr(""); setLogErr(""); setSmsStep("phone"); setShowForgot(false); }} className="w-full text-center text-xs font-medium text-[#007BFF] hover:underline mt-4">
          Accedi invece con email e password
        </button>
      )}

      <p className="text-[11px] text-muted-foreground/70 mt-4 text-center">
        {smsMode
          ? "Non servono credenziali: entri con il tuo numero di cellulare, se l'amministratore lo ha registrato in anagrafica."
          : "Le credenziali ti sono fornite dall'amministrazione."}
      </p>
    </div>
  </div>
);
